export function computeAdditionalFeesByShippingMode(shippingMode) {
  const delayedShippingFees = shippingMode?.selectedDeliveryDateDelayed && shippingMode?.delayedShipping?.price;
  const weatherHoldFees = shippingMode?.canBeBlocked && shippingMode?.weatherHoldChecked &&
    shippingMode?.weatherHold?.price;
  const woodenCaseFees = shippingMode?.userHasChosenWoodenCase && shippingMode?.woodenCase?.price;

  return {
    delayedShippingFees,
    weatherHoldFees,
    woodenCaseFees
  };
}

export function computeAdditionalFees(cart, t) {
  const selectedShippingModes = [
    cart.shippingMode,
    cart.primeurShippingMode,
    cart.prearrivalShippingMode
  ].filter(Boolean);

  const totalFees = selectedShippingModes.reduce(
    (acc, mode) => {
      const {
        delayedShippingFees,
        weatherHoldFees,
        woodenCaseFees
      } = computeAdditionalFeesByShippingMode(mode);

      acc.delayedShippingFees += delayedShippingFees;
      acc.weatherHoldFees += weatherHoldFees;
      acc.woodenCaseFees += woodenCaseFees;

      return acc;
    },
    {
      delayedShippingFees: 0,
      weatherHoldFees: 0,
      woodenCaseFees: 0
    }
  );

  return {
    shouldShow: !!(totalFees?.delayedShippingFees || totalFees?.weatherHoldFees || totalFees?.woodenCaseFees),
    label: t('account.orders.details.additionalFees'),
    value: Number(totalFees?.delayedShippingFees + totalFees?.weatherHoldFees + totalFees?.woodenCaseFees) || 0
  };
}
